import FieldSubtask from "./FieldSubtask";
import DocumentSubtask from "./DocumentSubtask";
import PhotoSubtask from "./PhotoSubtask";
import VideoSubtask from "./VideoSubtask";
import AudioSubtask from "./AudioSubtask";

const RENDERER_MAP = {
  FIELD: FieldSubtask,
  DOCUMENT: DocumentSubtask,
//   PHOTO: PhotoSubtask,
//   VIDEO: VideoSubtask,
//   AUDIO: AudioSubtask,
  PHOTO: DocumentSubtask,
  VIDEO: DocumentSubtask,
  AUDIO: DocumentSubtask,
};

export const SubtaskRenderer = ({ subtask }) => {
  const Component = RENDERER_MAP[subtask.task_type.type_code];

  if (!Component) return null;
  return <Component subtask={subtask} />;
};
